import Dexie, { Table } from 'dexie';

export interface ImportacaoPreMontadaDB {
	id: string
	fileName: string
	tipo: 'clientes' | 'produtos'
	blob: Blob
	mapeamento: Record<string, string>
	grupoEconomicoId: string | null
	lojas: string[]
	records: number
	createdAt: string
}

class AppDB extends Dexie {
	importacoes!: Table<ImportacaoPreMontadaDB, string>;

	constructor() {
		super('importacoes-db');

		this.version(1).stores({
			importacoes: '&id,fileName,tipo,createdAt',
		});
	}
}

export const db = new AppDB();
